import { __assign, __rest } from "tslib";
import React, { Children, cloneElement } from 'react';
import { twMerge } from 'tailwind-merge';
export var Breadcrumbs = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("nav", __assign({ "aria-label": "Breadcrumb", className: className }, rest), Children.toArray(children).map(function (child) {
        return cloneElement(child, {
            className: twMerge("[&:not(:last-of-type)]:after:content-['/']\n                    [&:not(:last-of-type)]:after:inline-block\n                    [&:not(:last-of-type)]:after:mx-2\n                    [&:not(:last-of-type)]:after:text-mirage\n                    [&:not(:last-of-type)]:text-cerulean-default\n                    last-of-type:text-mirage\n                    hover:underline\n                    last:hover:pointer-events-none\n                    last:hover:no-underline\n                    ", child.props.className),
        });
    })));
};
export default Breadcrumbs;
